export default __webpack_public_path__ + "static/media/Level11.76cba463.svg";